export enum EscrowAccountStatus {
    Pending = 'pending',
}
